import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Reload the tablets ")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Clear cache & reload Kiosk Url?", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  class: "btn btn-outline-dark"
}, " Cancel ", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Take a snapshot ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, "Request application snapshot?", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  class: "btn btn-outline-dark"
}, " Cancel ", -1)
const _hoisted_7 = { class: "container-fluid tablets-page" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "card mb-2" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Kiosk tablets")
], -1)
const _hoisted_14 = { class: "col-3" }
const _hoisted_15 = { class: "form-check form-check-inline" }
const _hoisted_16 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_17 = { class: "form-check form-check-inline" }
const _hoisted_18 = {
  class: "form-check-label",
  for: "flexCheckChecked"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn-group btn-group-sm",
  role: "group"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-outline-dark",
    "data-bs-toggle": "modal",
    "data-bs-target": "#takeSnapshotModal"
  }, " Snapshot "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-outline-dark",
    "data-bs-toggle": "modal",
    "data-bs-target": "#reloadTabletModal"
  }, " Reload ")
], -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "offset-3 col-3" }
const _hoisted_23 = { class: "input-group mb-1 mt-1" }
const _hoisted_24 = { class: "col" }
const _hoisted_25 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-list" }, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grid-3x3-gap" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("a", {
  class: "btn btn-light",
  "data-bs-toggle": "collapse",
  href: "#filterCollapse",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "filterCollapse"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-filter" })
], -1)
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = {
  class: "collapse mb-2",
  id: "filterCollapse"
}
const _hoisted_34 = { class: "card card-body" }
const _hoisted_35 = { class: "row mt-1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword",
  class: "col-1 col-form-label"
}, "Group", -1)
const _hoisted_37 = { class: "col-3" }
const _hoisted_38 = {
  key: 0,
  class: "col-12"
}
const _hoisted_39 = { class: "statusbar" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-tablet-landscape" }, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-display" }, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { href: "javascript:void(0)" }
const _hoisted_45 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-camera-fill" }, null, -1)
const _hoisted_47 = ["onClick"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
const _hoisted_49 = [
  _hoisted_48
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_component = _resolveComponent("modal-component")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_popover = _resolveComponent("popover")!
  const _component_table_lite = _resolveComponent("table-lite")!
  const _component_tablet_tile = _resolveComponent("tablet-tile")!
  const _directive_role = _resolveDirective("role")!
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal_component, {
      id: "reloadTabletModal",
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetComponentState()))
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      body: _withCtx(() => [
        _hoisted_2
      ]),
      footer: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("button", {
          type: "button",
          "data-bs-dismiss": "modal",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reloadTablets && _ctx.reloadTablets(...args))),
          class: "btn btn-outline-dark"
        }, " Reload ")
      ]),
      _: 1
    }),
    _createVNode(_component_modal_component, {
      id: "takeSnapshotModal",
      onOnClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetComponentState()))
    }, {
      header: _withCtx(() => [
        _hoisted_4
      ]),
      body: _withCtx(() => [
        _hoisted_5
      ]),
      footer: _withCtx(() => [
        _hoisted_6,
        _createElementVNode("button", {
          type: "button",
          "data-bs-dismiss": "modal",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.takeSnapshot && _ctx.takeSnapshot(...args))),
          class: "btn btn-outline-dark"
        }, " Yes ")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.onlineFilterOn) = $event)),
                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onStatusFilterChange && _ctx.onStatusFilterChange(...args))),
                      class: "form-check-input",
                      name: "status",
                      type: "checkbox",
                      id: "flexCheckDefault"
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.onlineFilterOn]
                    ]),
                    _createElementVNode("label", _hoisted_16, " Online (" + _toDisplayString(_ctx.online) + ") ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.offlineFilterOn) = $event)),
                      onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onStatusFilterChange && _ctx.onStatusFilterChange(...args))),
                      class: "form-check-input",
                      name: "status",
                      type: "checkbox",
                      id: "flexCheckChecked",
                      checked: ""
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.offlineFilterOn]
                    ]),
                    _createElementVNode("label", _hoisted_18, " Offline (" + _toDisplayString(_ctx.offline) + ") ", 1)
                  ]),
                  (_ctx.filtersUsed)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21)), [
                        [_directive_role, void 0, "admin"]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchString) = $event)),
                      type: "test",
                      class: "form-control",
                      placeholder: "Search"
                    }, null, 512), [
                      [_vModelText, _ctx.searchString],
                      [_directive_debounce, _ctx.onSearch, "300ms"]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.switchView(_ctx.modes.LIST)))
                    }, _hoisted_27),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.switchView(_ctx.modes.GRID)))
                    }, _hoisted_29),
                    _hoisted_30
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.groupId,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.groupId) = $event)),
                    options: _ctx.groups,
                    reduce: (group) => group.DeviceGroupID,
                    label: "DeviceGroupName",
                    taggable: "",
                    multiple: "",
                    "onOption:deselected": _ctx.onGroupFilterChange,
                    "onOption:selected": _ctx.onGroupFilterChange
                  }, null, 8, ["modelValue", "options", "reduce", "onOption:deselected", "onOption:selected"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["row", {'tile-container': _ctx.viewMode == _ctx.modes.GRID}])
      }, [
        (_ctx.viewMode == _ctx.modes.LIST)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createVNode(_component_table_lite, {
                "is-slot-mode": true,
                columns: _ctx.table.columns,
                "is-static-mode": true,
                "is-re-search": true,
                "page-size": _ctx.perPage,
                rows: _ctx.items,
                total: _ctx.items.length,
                pageOptions: [],
                messages: {
              pagingInfo: '',
              pageSizeChangeLabel: '',
              gotoPageLabel: '',
              noDataAvailable: 'No data',
            }
              }, {
                status: _withCtx((data) => [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("span", {
                      style: _normalizeStyle({ color: data.value.Online ? 'green' : 'red' })
                    }, _hoisted_41, 4),
                    _createElementVNode("span", {
                      style: _normalizeStyle({ color: data.value.ScreenOn ? 'green' : 'red' })
                    }, _hoisted_43, 4)
                  ])
                ]),
                Name: _withCtx((data) => [
                  _createElementVNode("a", _hoisted_44, _toDisplayString(data.value.Name), 1)
                ]),
                actions: _withCtx((data) => [
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_popover, {
                      trigger: "hover",
                      content: "Snapshots",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {
                    name: 'TabletScreenshotsPage',
                    params: { id: data.value.id },
                  },
                          class: "btn btn-light"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_46
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_popover, {
                      trigger: "hover",
                      content: "Refresh kiosk page",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#reloadTabletModal",
                          onClick: ($event: any) => (_ctx.onSelect(data.value.Id)),
                          class: "btn btn-light"
                        }, _hoisted_49, 8, _hoisted_47)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _: 1
              }, 8, ["columns", "page-size", "rows", "total"])
            ]))
          : (_ctx.viewMode == _ctx.modes.GRID)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-2 mb-3",
                  key: item.Id
                }, [
                  _createVNode(_component_tablet_tile, { item: item }, null, 8, ["item"])
                ]))
              }), 128))
            : _createCommentVNode("", true)
      ], 2)
    ])
  ], 64))
}